const PROFITABILITY_PERMISSION = "CAN_READ_PROFITABILITY";

function permissionCodes(store = {}) {
  return (Array.isArray(store.permissions) ? store.permissions : [])
    .map((permission) => String(permission || "").trim().toUpperCase());
}

export function hasProfitabilityPermission(store = {}) {
  return Boolean(
    store.isOwner ||
      store.is_owner ||
      String(store.membershipType || store.membership_type || "").toLowerCase() ===
        "owner" ||
      permissionCodes(store).some((permission) =>
        [PROFITABILITY_PERMISSION, "OWNER", "OWNER_FULL_ACCESS"].includes(permission),
      ),
  );
}

export function canRenderProfitability(serverAccess, store = {}) {
  return serverAccess === true && hasProfitabilityPermission(store);
}

export function canRenderCurrencyProfitability(
  currencyGroup,
  storeRows,
  resolveStore,
) {
  if (
    currencyGroup?.canViewProfitability !== true &&
    currencyGroup?.profitabilityAccess !== true
  ) return false;
  const rows = (storeRows || []).filter(
    (row) => row.currency === currencyGroup.currency,
  );
  return rows.length > 0 && rows.every((row) =>
    canRenderProfitability(
      row.canViewProfitability ?? row.profitabilityAccess,
      resolveStore(row.id),
    ),
  );
}

export function canRenderMetric(key, value, profitabilityAllowed) {
  if (!String(key).toLowerCase().includes("profit")) return true;
  return profitabilityAllowed === true && value != null && !Number.isNaN(Number(value));
}

export function profitabilityDefinition(calculation = {}) {
  const revenue = calculation.net_sales_amount ?? calculation.revenue;
  const cost =
    calculation.allocated_inventory_cost ?? calculation.cost_of_goods_sold;
  const expenses =
    calculation.recorded_expenses_amount ?? calculation.expenses;
  const gross = calculation.gross_profit_amount ?? calculation.gross_profit;
  const net =
    calculation.profit_after_recorded_expenses ?? calculation.net_profit;
  const description =
    calculation.calculation_description || calculation.definition || "";
  return {
    gross: `${
      calculation.gross_profit_definition ||
      "Gross profit measures revenue remaining after product costs."
    } Net sales (${revenue ?? "—"}) − cost of sold inventory (${cost ?? "—"}) = gross profit (${gross ?? "—"}).`,
    net: `${
      calculation.net_profit_definition ||
      description ||
      "Profit after recorded expenses subtracts recorded store expenses from gross profit."
    } Gross profit (${gross ?? "—"}) − recorded expenses (${expenses ?? "—"}) = profit after recorded expenses (${net ?? "—"}).`,
  };
}

export { PROFITABILITY_PERMISSION };
